import React from "react";
import "./UserDashboard.css";
import Logo from "../../assets/Footer/Sundar logo.png"
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LensBlurIcon from '@mui/icons-material/LensBlur';
import HomeIcon from '@mui/icons-material/Home';
import SwapCallsIcon from '@mui/icons-material/SwapCalls';
import ReceiptIcon from '@mui/icons-material/Receipt';
import FolderIcon from '@mui/icons-material/Folder';
import MarkChatUnreadIcon from '@mui/icons-material/MarkChatUnread';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import SearchIcon from '@mui/icons-material/Search';
import FlagIcon from '@mui/icons-material/Flag';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AddToDriveIcon from '@mui/icons-material/AddToDrive';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import SettingsIcon from '@mui/icons-material/Settings';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
export default function UserDashboaard() {
  return (
    <>
      <div className="container-fluid  p-0 m-0">
        <div className="row  p-0 m-0">
          <div className="col-3 sideNavmain">
          <div className="sideNav position-fixed">
            <div
              className="d-flex align-items-center mb-3 mb-md-0 me-md-auto link-dark text-decoration-none py-2"
            >
              <span> <ViewHeadlineIcon/> </span>
              <img className="mx-1 iconHovers" src={Logo} height={40} alt="" />
              <span className="fs-4 mx-1 cursor-pointer">BOMSIE</span>
            </div>

            <hr className="p-0 m-0" />

            <section className="pt-2 m-0">
  <div className="container p-0 m-0 w-100">
    <div className="row d-flex  align-items-center p-0 m-0">
      <div className="col p-0 m-0">
        <div className="">
          <div className=" p-0 m-0">
            <div className="d-flex text-black">
              <div className="flex-shrink-0">
                <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-profiles/avatar-1.webp"
                  alt="Generic placeholder image" height={50} className="rounded b-none bg-transparent"
                 />
              </div>
              <div className="flex-grow-1 ms-3">
                <h5 className="mb-1">Danny McLoan</h5>
                <p className="mb-2" style={{color: "#2b2a2a"}}>Senior Journalist</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
            <hr className="p-0 m-0" />
            <div className="accordion accordion-flush" id="accordionFlushExample">
              <div className="accordion-item border-0">
                <h2 className="accordion-header" id="flush-headingOne">
                  <button
                    className="newAccor p-0 pb-3  m-0 fs-6 bg-transparent text-dark border-white collapsed "
                    type="button"
                  >
                <HomeIcon className="mx-1 iconHovers" />    Dashboard 
                  </button>
                </h2>
              </div>
              <div className="accordion-item border-0 ">
                <h2 className="accordion-header" id="flush-headingTwo">
                  <button
                    className="newAccor p-0 pb-3  m-0 fs-6 bg-transparent text-dark border-0 collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseTwo"
                    aria-expanded="false"
                    aria-controls="flush-collapseTwo"
                  >
                 <LensBlurIcon className="mx-1 iconHovers"/>   Residents<KeyboardArrowDownIcon/>
                  </button>
                </h2>
                <div
                  id="flush-collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingTwo"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body bg-light py-2 d-flex justify-content-between d-flex">Placeholder<ArrowRightAltIcon/></div>
                </div>
              </div>
              <div className="accordion-item border-0">
                <h2 className="accordion-header" id="flush-headingThree">
                  <button
                    className="newAccor p-0 pb-3  m-0 fs-6 bg-transparent text-dark border-0 collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseThree"
                    aria-expanded="false"
                    aria-controls="flush-collapseThree"
                  >
                    <SwapCallsIcon className="mx-1 iconHovers"/>Complaints/req<KeyboardArrowDownIcon/>
                  </button>
                </h2>
                <div
                  id="flush-collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingThree"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body bg-light py-2 d-flex justify-content-between  ">Placeholder <ArrowRightAltIcon/></div>
                </div>
              </div>

              <div className="accordion-item border-0">
                <h2 className="accordion-header" id="flush-headingFour">
                  <button
                    className="newAccor p-0 pb-3  m-0 fs-6 bg-transparent text-dark border-0 collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseFour"
                    aria-expanded="false"
                    aria-controls="flush-collapseFour"
                  >
                    <ReceiptIcon className="mx-1 iconHovers"/>Bills<KeyboardArrowDownIcon/>
                  </button>
                </h2>
                <div
                  id="flush-collapseFour"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingFour"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body bg-light py-2 d-flex justify-content-between  ">Placeholder <ArrowRightAltIcon/></div>
                </div>
              </div>

              <div className="accordion-item border-0">
                <h2 className="accordion-header" id="flush-headingFive">
                  <button
                    className="newAccor p-0 pb-3  m-0 fs-6 bg-transparent text-dark border-0 collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseFive"
                    aria-expanded="false"
                    aria-controls="flush-collapseFive"
                  >
                  <FolderIcon className="mx-1 iconHovers"/>E-Lane<KeyboardArrowDownIcon/>
                  </button>
                </h2>
                <div
                  id="flush-collapseFive"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingFour"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body bg-light py-2 d-flex justify-content-between  ">
                    Placeholder <ArrowRightAltIcon/>
                  </div>
                </div>
              </div>

              <div className="accordion-item border-0">
                <h2 className="accordion-header" id="flush-headingSix">
                  <button
                    className="newAccor p-0 pb-3  m-0 fs-6 bg-transparent text-dark border-0 collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseSix"
                    aria-expanded="false"
                    aria-controls="flush-collapseSix"
                  >
                   <NotificationsNoneIcon className="mx-1 iconHovers"/>Notifications<KeyboardArrowDownIcon/>
                  </button>
                </h2>
                <div
                  id="flush-collapseSix"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingSix"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body bg-light py-2 d-flex justify-content-between  ">
                    Placeholder <ArrowRightAltIcon/>
                  </div>
                </div>
              </div>

              <div className="accordion-item border-0">
                <h2 className="accordion-header" id="flush-headingSeven">
                  <button
                    className="newAccor p-0 pb-3  m-0 fs-6 bg-transparent text-dark border-0 collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseSeven"
                    aria-expanded="false"
                    aria-controls="flush-collapseSeven"
                  >
                    <MarkChatUnreadIcon className="mx-1 iconHovers"/>Chat<KeyboardArrowDownIcon/>
                  </button>
                </h2>
                <div
                  id="flush-collapseSeven"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingSeven"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body bg-light py-2 d-flex justify-content-between  ">
                    Placeholder <ArrowRightAltIcon/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div className="col innerContent d-flex justify-content-center align-items-center mt-3">
          <div className="row innerContentcenter mt-1 mb-1">
          <section  >
  <div class="container py-5 h-100">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col col-xl-10">
        <div class="card mb-5" style={{borderRadius: "15px"}}>
          <div class="card-body p-4">
            <h3 class="mb-3">Program Title</h3>
            <p class="small mb-0"><i class="far fa-star fa-lg"></i> <span class="mx-2">|</span> Created by
              <strong>MDBootstrap</strong> on 11 April , 2021</p>
            <hr class="my-4"/>
            <div class="d-flex justify-content-start align-items-center">
              <p class="mb-0 text-uppercase"><i class="fas fa-cog me-2"></i> <span
                  class="text-muted small">settings</span></p>
              <p class="mb-0 text-uppercase"><i class="fas fa-link ms-4 me-2"></i> <span
                  class="text-muted small">program link</span></p>
              <p class="mb-0 text-uppercase"><i class="fas fa-ellipsis-h ms-4 me-2"></i> <span
                  class="text-muted small">program link</span>
                <span class="ms-3 me-4">|</span></p>
              <a href="#!">
                <img src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/avatar-2.webp" alt="avatar"
                  class="img-fluid rounded-circle me-3" width="35"/>
              </a>
              <button type="button" class="btn btn-outline-dark btn-sm btn-floating">
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="card" style={{borderRadius: "15px;"}}>
          <div class="card-body p-4">
            <h3 class="mb-3">Company Culture</h3>
            <p class="small mb-0"><i class="fas fa-star fa-lg text-warning"></i> <span class="mx-2">|</span>
              Public <span class="mx-2">|</span> Updated by <strong>MDBootstrap</strong> on 11 April , 2021
            </p>
            <hr class="my-4"/>
            <div class="d-flex justify-content-start align-items-center">
              <p class="mb-0 text-uppercase"><i class="fas fa-cog me-2"></i> <span
                  class="text-muted small">settings</span></p>
              <p class="mb-0 text-uppercase"><i class="fas fa-link ms-4 me-2"></i> <span
                  class="text-muted small">program link</span></p>
              <p class="mb-0 text-uppercase"><i class="fas fa-ellipsis-h ms-4 me-2"></i> <span
                  class="text-muted small">program link</span>
                <span class="ms-3 me-4">|</span></p>
              <a href="#!">
                <img src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/avatar-2.webp" alt="avatar"
                  class="img-fluid rounded-circle me-1" width="35"/>
              </a>
              <a href="#!">
                <img src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/avatar-3.webp" alt="avatar"
                  class="img-fluid rounded-circle me-1" width="35"/>
              </a>
              <a href="#!">
                <img src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/avatar-4.webp" alt="avatar"
                  class="img-fluid rounded-circle me-1" width="35"/>
              </a>
              <a href="#!">
                <img src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/avatar-5.webp" alt="avatar"
                  class="img-fluid rounded-circle me-3" width="35"/>
              </a>
              <button type="button" class="btn btn-outline-dark btn-sm btn-floating">
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section  >
  <div class="container py-5 h-100">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col col-xl-10">
        <div class="card mb-5" style={{borderRadius: "15px"}}>
          <div class="card-body p-4">
            <h3 class="mb-3">Program Title</h3>
            <p class="small mb-0"><i class="far fa-star fa-lg"></i> <span class="mx-2">|</span> Created by
              <strong>MDBootstrap</strong> on 11 April , 2021</p>
            <hr class="my-4"/>
            <div class="d-flex justify-content-start align-items-center">
              <p class="mb-0 text-uppercase"><i class="fas fa-cog me-2"></i> <span
                  class="text-muted small">settings</span></p>
              <p class="mb-0 text-uppercase"><i class="fas fa-link ms-4 me-2"></i> <span
                  class="text-muted small">program link</span></p>
              <p class="mb-0 text-uppercase"><i class="fas fa-ellipsis-h ms-4 me-2"></i> <span
                  class="text-muted small">program link</span>
                <span class="ms-3 me-4">|</span></p>
              <a href="#!">
                <img src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/avatar-2.webp" alt="avatar"
                  class="img-fluid rounded-circle me-3" width="35"/>
              </a>
              <button type="button" class="btn btn-outline-dark btn-sm btn-floating">
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="card" style={{borderRadius: "15px;"}}>
          <div class="card-body p-4">
            <h3 class="mb-3">Company Culture</h3>
            <p class="small mb-0"><i class="fas fa-star fa-lg text-warning"></i> <span class="mx-2">|</span>
              Public <span class="mx-2">|</span> Updated by <strong>MDBootstrap</strong> on 11 April , 2021
            </p>
            <hr class="my-4"/>
            <div class="d-flex justify-content-start align-items-center">
              <p class="mb-0 text-uppercase"><i class="fas fa-cog me-2"></i> <span
                  class="text-muted small">settings</span></p>
              <p class="mb-0 text-uppercase"><i class="fas fa-link ms-4 me-2"></i> <span
                  class="text-muted small">program link</span></p>
              <p class="mb-0 text-uppercase"><i class="fas fa-ellipsis-h ms-4 me-2"></i> <span
                  class="text-muted small">program link</span>
                <span class="ms-3 me-4">|</span></p>
              <a href="#!">
                <img src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/avatar-2.webp" alt="avatar"
                  class="img-fluid rounded-circle me-1" width="35"/>
              </a>
              <a href="#!">
                <img src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/avatar-3.webp" alt="avatar"
                  class="img-fluid rounded-circle me-1" width="35"/>
              </a>
              <a href="#!">
                <img src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/avatar-4.webp" alt="avatar"
                  class="img-fluid rounded-circle me-1" width="35"/>
              </a>
              <a href="#!">
                <img src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/avatar-5.webp" alt="avatar"
                  class="img-fluid rounded-circle me-3" width="35"/>
              </a>
              <button type="button" class="btn btn-outline-dark btn-sm btn-floating">
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
            </div>
          </div>
          <div className="col-1 rightNav d-flex justify-content-center">
          <div class="d-flex flex-column flex-shrink-0 position-fixed mt-3" style={{width: "4.5rem"}}>
          <div class="dropdown ">
      <a href="#" class="d-flex align-items-center justify-content-center p-3 link-dark text-decoration-none dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        <SearchIcon/>
      </a>
      <ul class="dropdown-menu text-small shadow">
        <li><a class="dropdown-item" href="#">New project...</a></li>
        <li><a class="dropdown-item" href="#">Settings</a></li>
        <li><a class="dropdown-item" href="#">Profile</a></li>
        <li><hr class="dropdown-divider"/></li>
        <li><a class="dropdown-item" href="#">Sign out</a></li>
      </ul>
    </div>
  
    <div class="dropdown">
      <a href="#" class="d-flex align-items-center justify-content-center p-3 link-dark text-decoration-none dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        <LensBlurIcon/>
      </a>
      <ul class="dropdown-menu text-small shadow">
        <li><a class="dropdown-item" href="#">New project...</a></li>
        <li><a class="dropdown-item" href="#">Settings</a></li>
        <li><a class="dropdown-item" href="#">Profile</a></li>
        <li><hr class="dropdown-divider"/></li>
        <li><a class="dropdown-item" href="#">Sign out</a></li>
      </ul>
    </div>
    <div class="dropdown">
      <a href="#" class="d-flex align-items-center justify-content-center p-3 link-dark text-decoration-none dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        <NotificationsNoneIcon/>
      </a>
      <ul class="dropdown-menu text-small shadow">
        <li><a class="dropdown-item" href="#">New project...</a></li>
        <li><a class="dropdown-item" href="#">Settings</a></li>
        <li><a class="dropdown-item" href="#">Profile</a></li>
        <li><hr class="dropdown-divider"/></li>
        <li><a class="dropdown-item" href="#">Sign out</a></li>
      </ul>
    </div>
    <div class="dropdown">
      <a href="#" class="d-flex align-items-center justify-content-center p-3 link-dark text-decoration-none dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        <FlagIcon/>
      </a>
      <ul class="dropdown-menu text-small shadow">
        <li><a class="dropdown-item" href="#">New project...</a></li>
        <li><a class="dropdown-item" href="#">Settings</a></li>
        <li><a class="dropdown-item" href="#">Profile</a></li>
        <li><hr class="dropdown-divider"/></li>
        <li><a class="dropdown-item" href="#">Sign out</a></li>
      </ul>
    </div>
    <div class="dropdown">
      <a href="#" class="d-flex align-items-center justify-content-center p-3 link-dark text-decoration-none dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        <CalendarMonthIcon/>
      </a>
      <ul class="dropdown-menu text-small shadow">
        <li><a class="dropdown-item" href="#">New project...</a></li>
        <li><a class="dropdown-item" href="#">Settings</a></li>
        <li><a class="dropdown-item" href="#">Profile</a></li>
        <li><hr class="dropdown-divider"/></li>
        <li><a class="dropdown-item" href="#">Sign out</a></li>
      </ul>
    </div>
    <div class="dropdown">
      <a href="#" class="d-flex align-items-center justify-content-center p-3 link-dark text-decoration-none dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        <AddToDriveIcon/>
      </a>
      <ul class="dropdown-menu text-small shadow">
        <li><a class="dropdown-item" href="#">New project...</a></li>
        <li><a class="dropdown-item" href="#">Settings</a></li>
        <li><a class="dropdown-item" href="#">Profile</a></li>
        <li><hr class="dropdown-divider"/></li>
        <li><a class="dropdown-item" href="#">Sign out</a></li>
      </ul>
    </div>
    <div class="dropdown">
      <a href="#" class="d-flex align-items-center justify-content-center p-3 link-dark text-decoration-none dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        <WorkspacesIcon/>
      </a>
      <ul class="dropdown-menu text-small shadow">
        <li><a class="dropdown-item" href="#">New project...</a></li>
        <li><a class="dropdown-item" href="#">Settings</a></li>
        <li><a class="dropdown-item" href="#">Profile</a></li>
        <li><hr class="dropdown-divider"/></li>
        <li><a class="dropdown-item" href="#">Sign out</a></li>
      </ul>
    </div>
    <div class="dropdown">
      <a href="#" class="d-flex align-items-center justify-content-center p-3 link-dark text-decoration-none dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        <SettingsIcon className="rotation"/>
      </a>
      <ul class="dropdown-menu text-small shadow">
        <li><a class="dropdown-item" href="#">New project...</a></li>
        <li><a class="dropdown-item" href="#">Settings</a></li>
        <li><a class="dropdown-item" href="#">Profile</a></li>
        <li><hr class="dropdown-divider"/></li>
        <li><a class="dropdown-item" href="#">Sign out</a></li>
      </ul>
    </div>
    <div class="dropdown">
      <a href="#" class="d-flex align-items-center justify-content-center p-3 link-dark text-decoration-none dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        <ExitToAppIcon/>
      </a>
      <ul class="dropdown-menu text-small shadow">
        <li><a class="dropdown-item" href="#">New project...</a></li>
        <li><a class="dropdown-item" href="#">Settings</a></li>
        <li><a class="dropdown-item" href="#">Profile</a></li>
        <li><hr class="dropdown-divider"/></li>
        <li><a class="dropdown-item" href="#">Sign out</a></li>
      </ul>
    </div>
  </div>   
          </div>
        </div>
      </div>
    </>
  );
}
